import React from "react";
import { Link } from "react-router-dom";

import { Button } from "@mui/material";

import PaperText from "../misc/PaperText";
import PaperFragment from "../misc/PaperFragment";

import { getLanguage } from "../../config/language/language";

/**
 * Used with react-error-boundary - if an error occurs, show this page.
 */
export default function UnexpectedError(props) {
    const location = props?.browser?.location;
    const state = location?.state;

    const message = props?.error?.message ?? `No error message given.`;
    const imgSrc = state?.status ? `https://http.cat/${state?.status}.jpg` : `${process.env.PUBLIC_URL}/images/books.jpg`;

    return (
        <>
            <PaperText center value={getLanguage().UNEXPECTED_ERROR_DESCRIPTION} />
            <PaperText
                center
                value={
                    <>
                        <Link to="/home" className="text-link">
                            <Button onClick={props.resetErrorBoundary}>{getLanguage().UNEXPECTED_ERROR_BUTTON_1}</Button>
                        </Link>
                        <Link to="/signin" className="text-link">
                            <Button onClick={props.resetErrorBoundary}>{getLanguage().UNEXPECTED_ERROR_BUTTON_2}</Button>
                        </Link>
                    </>
                }
            />

            <PaperFragment center value={<img src={imgSrc} alt="Unexpected error!" width="50%" />} />

            <PaperText center value={message} />
        </>
    );
}
